import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { LoadingScreenService } from "../../../services/loading-screen/loading-screen.service";
import { Service } from "../../../services";
import { GlobalService } from "../../../global.service";
import { Router } from "@angular/router";
import { PaymentSupportService } from "src/app/flash-payment/flash-payment-core/services/payment-support.service";
import { MessageService } from "src/app/message.service";

@Component({
  selector: "app-recharge-diff-plan",
  templateUrl: "./recharge-diff-plan.component.html",
  styleUrls: ["./recharge-diff-plan.component.sass"],
})
export class RechargeDiffPlanComponent implements OnInit {
  public subscriber;
  public prepaidBalance;
  public realAmountPlan = 50;
  @Input() validatePaymentGreaterThanBalance: boolean;
  @Input() balanceToRecharge;
  public IVU: number;
  // @Input() rechargeDiff;
  public otherAmount = 50;
  public token: string = sessionStorage.getItem("token");
  public selectBan;
  public typePayment;
  public address;
  public list;
  public otherMount;
  public typeOption = 1;
  public amount;
  public idProduct;
  public ivuState;
  public info;
  public valueRecharge = JSON.parse(
    atob(sessionStorage.getItem("getAccountDetails"))
  ).SubscriberInfo[0].planInfoField.socRateField;
  public valueRecharge2 = JSON.parse(
    atob(sessionStorage.getItem("getAccountDetails"))
  ).SubscriberInfo[0].planInfoField.socRateField;
  public totalPagar = 0;
  refundView = false;
  @Input() currentPlan;
  @Input() actualPrice;
  @Input() planToChange;
  @Input() descriptions;
  @Input() pricePlan;
  @Input() accounInfo;
  @Input() id;
  @Input() actualType;
  @Input() nextSoc;
  @Input() currentSoc;
  @Input() currentBalance: string;
  @Input() currentPlanPrice: string | number;
  @Input() subscriberNumber;
  @Output() updateAmount = new EventEmitter();
  @Output() updateIdProduct = new EventEmitter();
  @Output() updateTotalAmount = new EventEmitter();
  @Output() updateTax = new EventEmitter();
  @Output() updateScreenView = new EventEmitter();
  @Output() updateNroOrder = new EventEmitter<boolean>();
  @Output() updateinitializeData = new EventEmitter();
  @Output() updatePaymentSuccessValue = new EventEmitter<any>();
  public tax = 0;
  paymentRecieved: Subscription;
  balanceToRechargeFull: any;

  constructor(
    private loadingScreenService: LoadingScreenService,
    private services: Service,
    private global: GlobalService,
    private router: Router,
    private paymentSupport: PaymentSupportService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.paymentRecieved = this.global.paymentReceived.subscribe((value) => {
      if (value) {
        this.updateScreenView.emit(2.5);
        this.updatePaymentSuccessValue.emit(value);
      } else {
        this.global.notif(
          "Estimado cliente ha surgido un error en el procesamiento de su pago, por favor intente con otro metodo de pago."
        );
      }
    });
    this.balanceToRecharge = Number(this.balanceToRecharge);
    this.IVU = this.balanceToRecharge * 0.115;
    this.balanceToRechargeFull = this.balanceToRecharge + this.IVU;

    this.info = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).SubscriberInfo;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.subscriber = this.global.getSuscriberByDefault(this.selectBan);
    for (let i = 0; i < this.info.length; i++) {
      if (this.info[i].subscriberNumberField == this.subscriber) {
        this.realAmountPlan = this.info[i].planInfoField.socRateField;
      }
    }
    this.paymentMethod();
  }

  paymentMethod() {
    this.loadingScreenService.startLoading();
    this.services
      .paymentMethod(this.token, this.subscriber)
      .subscribe((data) => {
        if (data.success == true) {
          this.typePayment = data.formPaymentTypes;
          this.paymentAddress();
        } else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.error);
        }
      });
  }

  paymentAddress() {
    this.services
      .paymentAddress(this.token, this.subscriber)
      .subscribe((data) => {
        if (data.success == true) {
          this.address = data.address;
          this.rechargeList();
        } else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.error);
        }
      });
  }

  rechargeList() {
    this.services
      .rechargeList(this.token, this.subscriber, 2)
      .subscribe((data) => {
        this.loadingScreenService.stopLoading();
        if (data.success == true) {
          this.list = data.formProducts;
        } else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.error);
        }
      });
  }

  option(sw, sw2, amount, idProduct, ivuState) {
    if (this.global.validateSession() === true) {
      this.typeOption = sw2;
      const check_b = document.getElementById("check_b") as HTMLInputElement;
      if (sw2 == 0) {
        this.amount = amount;
        this.idProduct = idProduct;
        this.ivuState = ivuState;
        document.getElementById("option_a").className = "mnts-rcrg ";
        document.getElementById("option_b").className = "mnts-othr-2 vcenter";

        check_b.checked = false;
        for (let i = 0; i < this.list.length - 1; i++) {
          document.getElementById("option_" + i).className = "mnts-rcrg rcrg-a";
        }
        document.getElementById("option_" + sw).className =
          "mnts-rcrg on rcrg-a";
        const check = document.getElementById(
          "check_" + sw
        ) as HTMLInputElement;
        check.checked = true;
        this.valueRecharge = this.list[sw].productName;
      } else if (sw2 == 2) {
        this.amount = this.otherAmount;
        this.idProduct = idProduct;
        this.ivuState = ivuState;
        document.getElementById("option_b").className =
          "mnts-othr-2-on vcenter";
        check_b.checked = true;
        document.getElementById("option_a").className = "mnts-rcrg ";
        for (var i = 0; i < this.list.length - 1; i++) {
          document.getElementById("option_" + i).className = "mnts-rcrg rcrg-a";
        }
      } else {
        this.amount = amount;
        this.idProduct = idProduct;
        document.getElementById("option_a").className = "mnts-rcrg on rcrg-a";
        document.getElementById("option_b").className = "mnts-othr-2 vcenter";
        check_b.checked = false;
        for (let i = 0; i < this.list.length - 1; i++) {
          document.getElementById("option_" + i).className = "mnts-rcrg rcrg-a";
        }
      }
    }
  }

  continuePrepaidRecharge() {
    if (this.global.validateSession() == true) {
      if (this.typeOption == 2 || this.otherMount) {
        this.amount = this.valueRecharge2;
      }

      if (this.amount > 0) {
        if (this.amount >= 5) {
          if (this.amount <= 150) {
            if (this.idProduct != null) {
              this.tax = parseFloat(this.amount) * parseFloat(this.ivuState);
              this.totalPagar = parseFloat(this.amount) + this.tax;
              this.updateAmount.emit(this.amount);
              this.updateIdProduct.emit(this.idProduct);
              this.updateTotalAmount.emit(this.totalPagar);
              this.updateTax.emit(this.tax);
              this.updateScreenView.emit(3);
            } else {
              this.global.notif("El producto no tiene codigo.");
            }
          } else {
            this.global.notif("El monto no puede ser mayor a $150.00.");
          }
        } else {
          this.global.notif("El monto no puede ser menor a $5.00.");
        }
      } else {
        this.global.notif("Debe colocar un monto para la recarga.");
      }
    }
  }

  backPage() {
    if (this.global.validateSession()) {
      this.updateScreenView.emit(1);
    }
  }

  rechargeDiff() {
    this.applyChange();
  }

  applyChange() {
    if (this.global.validateSession() === true) {
      let date = new Date();
      let month;
      let month2 = date.getMonth() + 1;
      let day;
      let day2 = date.getDate();
      let year = date.getFullYear();
      if (month2 < 10) {
        month = "0" + month2;
      } else {
        month = month2;
      }
      if (day2 < 10) {
        day = "0" + day2;
      } else {
        day = day2;
      }
      let effectiveDate = year + "-" + month + "-" + day;
      this.loadingScreenService.startLoading();
      this.services
        .updateChangePlanPrepaid(
          this.accounInfo["accountTypeField"],
          this.accounInfo["accountSubtypeField"],
          effectiveDate,
          this.currentSoc,
          this.nextSoc,
          this.actualType,
          this.id,
          this.token,
          this.subscriberNumber
        )
        .subscribe((data) => {
          this.loadingScreenService.stopLoading();
          if (data.success == true) {
            this.updateGlobalPrepaidInfo();
            this.rechargeDiffDone();
          } else {
            if (data.desc === "SUCCESS" || data.desc === "COMPLETED") {
              this.updateGlobalPrepaidInfo();
              this.rechargeDiffDone();
            } else {
              this.manageError(data);
            }
          }
        });
    }
  }

  manageError(data) {
    if (data.code === "001") {
      this.global.notif(
        `Estimado cliente nuestro sistema indica que ha llegado al limite de Cambio de Plan en un mes.`
      );
      this.updateinitializeData.emit();
      this.messageService.sentMessage("canceled", {
        method: "Estimado cliente nuestro sistema indica que ha llegado al limite de Cambio de Plan en un mes.",
      });
      this.return();
     
    } else if (data.code === "002") {
      this.messageService.sentMessage("canceled", {
        method: "Cambio de plan no efectuado.",
      });
      this.refundView = true;
    } else if (data.code === "003") {
      this.global.notif(
        `Actualmente el sistema está presentando problemas de comunicación, por favor contacte a Soporte Operacional o intente nuevamente en los próximos minutos.`
      );
      this.messageService.sentMessage("canceled", {
        method: "Cambio de plan no efectuado.",
      });
      this.updateinitializeData.emit();
      this.return();
    }
  }

  updateGlobalPrepaidInfo() {
    this.global.prepaidDataForEvaluate.token = this.token;
    this.global.prepaidDataForEvaluate.socId = Number(this.nextSoc);
    this.global.prepaidDataForEvaluate.subscriber = this.subscriberNumber;
  }

  rechargeDiffDone() {
    let typeMessage = "prepaid";
    const amount = Number(this.balanceToRechargeFull).toFixed(2);
    if (this.global.validateSession()) {
      if (sessionStorage.getItem("canUseNewMethod")) {
        this.paymentSupport.paymentRefactorProcess(
          typeMessage,
          amount.toString(),
          this.selectBan,
          this.token
        );
      } else {
        this.global.newPaymentNoLimit(
          2,
          typeMessage,
          this.selectBan,
          atob(sessionStorage.getItem("defaultSubscriber")),
          amount,
          atob(sessionStorage.getItem("email")),
          sessionStorage.getItem("name"),
          "",
          this.token
        );
      }
    }
  }

  return() {
    this.router.navigate(["home"]);
  }
}
